import React, { useState, useRef } from "react";
import { useCases } from "../components/Context/CasesContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./TabsView.css";
import Nav from "../Navbar-footer/Nav";
import Foot from "../Navbar-footer/Foot.jsx";

import {
  FaHandHoldingHeart,
  FaHeartbeat,
  FaBookOpen,
  FaTint,
  FaAmbulance,
  FaChild,
} from "react-icons/fa";

import { FaUserGraduate, FaHandsHelping, FaArrowRight } from "react-icons/fa";

import { FaEnvelope, FaPhoneAlt, FaHeart } from "react-icons/fa";

function decodeToken(token) {
  try {
    const base64Url = token.split(".")[1];

    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    return JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join(""),
      ),
    );
  } catch (e) {
    return null;
  }
}

function TabsView() {
  const { cases } = useCases();

  const filtered = cases.filter((r) => r.status === "Active");

  const navigate = useNavigate();
  const donationSectionRef = useRef(null);
  const token = sessionStorage.getItem("token");

  const user = token ? decodeToken(token) : null;

  const API = process.env.REACT_APP_API_URL;

  /* =========================================
     STATES
  ========================================= */

  const [loadingId, setLoadingId] = useState(null);

  const [selectedAmounts, setSelectedAmounts] = useState({});

  const [customAmounts, setCustomAmounts] = useState({});

  /* GENERAL DONATION */

  const [generalAmount, setGeneralAmount] = useState(500);

  const [customGeneralAmount, setCustomGeneralAmount] = useState("");

  const [selectedService, setSelectedService] = useState("Food");

  const [generalLoading, setGeneralLoading] = useState(false);

  /* =========================================
     SERVICES
  ========================================= */

  const donationServices = [
    "Food",
    "Medical",
    "Education",
    "Blood Donation",
    "Emergency Relief",
  ];

  const generalAmounts = [250, 500, 1000, 2500];

  /* =========================================
     CAMPAIGN CONTENT
  ========================================= */

  const campaignContent = {
    Food: {
      heading: "Your Donation Can Fill A Child's Empty Plate!",

      subheading:
        "Every meal you donate brings hope to hungry children and families.",

      labels: ["10 Meals", "20 Meals", "50 Meals", "100 Meals"],
    },

    Medical: {
      heading: "Help Save A Life Through Medical Support",

      subheading:
        "Your support can provide urgent treatment and critical medical care.",

      labels: ["Medicines", "Tests", "Emergency Care", "ICU Support"],
    },

    Education: {
      heading: "Support Education For Underprivileged Children",

      subheading: "Education can transform lives and create brighter futures.",

      labels: ["Books", "School Kits", "Tuition Help", "Digital Learning"],
    },

    Other: {
      heading: "Support This Meaningful Campaign",

      subheading:
        "Every contribution creates positive impact in someone's life.",

      labels: ["Support", "Help", "Donate", "Contribute"],
    },
  };

  /* =========================================
     CAMPAIGN DONATION
  ========================================= */

  const handleDonate = async (req) => {
    if (!token || !user) {
      return navigate("/login");
    }

    const selectedAmount = selectedAmounts[req._id];

    const customAmount = customAmounts[req._id];

    const amount =
      customAmount && customAmount > 0
        ? Number(customAmount)
        : Number(selectedAmount);

    if (!amount || amount <= 0) {
      alert("Please select donation amount");

      return;
    }

    try {
      setLoadingId(req._id);

      const { data } = await axios.post(
        `${API}/api/cases/create-donation-order`,
        {
          amount,
          caseId: req._id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const rzpOptions = {
        key: data.key,

        amount: data.amount,

        currency: "INR",

        name: "Sarv Sahayata Sangathan",

        description: `Donation for ${req.title}`,

        order_id: data.orderId,

        prefill: {
          name: user.name,
          email: user.email,
        },

        handler: async (response) => {
          await axios.post(
            `${API}/api/cases/verify-donation`,
            {
              razorpay_order_id: response.razorpay_order_id,

              razorpay_payment_id: response.razorpay_payment_id,

              razorpay_signature: response.razorpay_signature,

              caseId: req._id,

              amount,
            },

            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );

          alert("🎉 Donation Successful!");

          window.location.reload();
        },
      };

      const rzp = new window.Razorpay(rzpOptions);

      rzp.open();
    } catch (err) {
      console.error(err);

      alert("❌ Something went wrong");
    } finally {
      setLoadingId(null);
    }
  };

  /* =========================================
     GENERAL DONATION
  ========================================= */

  const handleGeneralDonation = async () => {
    try {
      if (!token || !user) {
        navigate("/login");
        return;
      }

      const finalAmount =
        customGeneralAmount && Number(customGeneralAmount) > 0
          ? Number(customGeneralAmount)
          : generalAmount;

      if (!finalAmount || finalAmount <= 0) {
        alert("Please enter valid amount");

        return;
      }

      setGeneralLoading(true);

      const { data } = await axios.post(
        `${API}/api/cases/create-donation-order`,
        {
          amount: finalAmount,
          caseId: "general_donation",
          service: selectedService,
        },

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = {
        key: data.key,

        amount: data.amount,

        currency: "INR",

        name: "Sarv Sahayata Sangathan",

        description: `${selectedService} Donation`,

        order_id: data.orderId,

        prefill: {
          name: user.name,
          email: user.email,
        },

        handler: async function (response) {
          try {
            await axios.post(
              `${API}/api/cases/verify-donation`,

              {
                razorpay_order_id: response.razorpay_order_id,

                razorpay_payment_id: response.razorpay_payment_id,

                razorpay_signature: response.razorpay_signature,

                amount: finalAmount,

                caseId: "general_donation",

                service: selectedService,
              },

              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            );

            alert("❤️ Donation Successful");

            setCustomGeneralAmount("");

            setGeneralAmount(500);
          } catch (error) {
            console.error(error);

            alert("Payment verification failed");
          }
        },

        theme: {
          color: "#d32f2f",
        },
      };

      const razor = new window.Razorpay(options);

      razor.open();
    } catch (error) {
      console.error(error);

      alert("Something went wrong");
    } finally {
      setGeneralLoading(false);
    }
  };

  return (
    <>
      <Nav />

      <div className="tabs-view-container">
        {/* TOP BAR */}

        <div className="ngo-top-bar">
          <div className="ngo-top-item">
            <FaEnvelope className="ngo-icon" />
            <span>sarvsahayatasangathan@gmail.com</span>
          </div>

          <div className="ngo-top-item">
            <FaPhoneAlt className="ngo-icon" />
            <span>+91-9317803125</span>
          </div>

          <div className="ngo-top-item">
            <FaHeart className="ngo-icon" />
            <span>India's Trusted Non-Profit Organization</span>
          </div>
        </div>

        {/* HERO */}

        <div className="tabs-heading">
          <span className="hero-badge">Helping Humanity With Care</span>

          <h2>Food, Medical & Educational Support For Every Life In Need</h2>

          <p>
            Every contribution creates hope, transforms lives, and helps us
            support families across India.
          </p>
        </div>

        {/* CAMPAIGNS */}

        <div className="case-list">
          {filtered.length > 0 ? (
            filtered.map((req) => {
              const pending = req.goalAmount - req.amountCollected;

              const progress = Math.min(
                (req.amountCollected / req.goalAmount) * 100,
                100,
              );

              const currentContent =
                campaignContent[req.category] || campaignContent["Other"];

              return (
                <div className="case-card" key={req._id}>
                  {/* IMAGE */}

                  <div className="case-left">
                    {req.image ? (
                      <img
                        src={`${API}${req.image}`}
                        alt={req.title}
                        className="case-img"
                      />
                    ) : (
                      <div className="case-img placeholder">No Image</div>
                    )}
                  </div>

                  {/* CONTENT */}

                  <div className="case-right">
                    <p className="campaign-category">{req.category}</p>

                    <h2 className="campaign-main-heading">
                      {currentContent.heading}
                    </h2>

                    <h3 className="campaign-title">{req.title}</h3>

                    <p className="campaign-subheading">
                      {currentContent.subheading}
                    </p>

                    <p className="campaign-description">{req.description}</p>

                    {req.beneficiaries && (
                      <div className="beneficiary-box">
                        👥 Beneficiaries:
                        <span> {req.beneficiaries}</span>
                      </div>
                    )}

                    {/* AMOUNT */}

                    <div className="amount-section">
                      <h3>
                        ₹{req.amountCollected?.toLocaleString()} raised of ₹
                        {req.goalAmount?.toLocaleString()}
                      </h3>
                    </div>

                    {/* PROGRESS */}

                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{
                          width: `${progress}%`,
                        }}
                      ></div>
                    </div>

                    <p className="pending-text">
                      ₹{pending > 0 ? pending.toLocaleString() : 0} still needed
                    </p>

                    {/* OPTIONS */}

                    <div className="donation-options">
                      {req.quickAmounts?.map((amt, index) => (
                        <button
                          key={amt}
                          className={`amount-btn ${
                            selectedAmounts[req._id] === amt
                              ? "active-amount"
                              : ""
                          }`}
                          onClick={() =>
                            setSelectedAmounts((prev) => ({
                              ...prev,
                              [req._id]: amt,
                            }))
                          }
                        >
                          <div className="amount-label">
                            {currentContent.labels[index]}
                          </div>

                          <div className="amount-price">₹{amt}</div>
                        </button>
                      ))}
                    </div>

                    {/* CUSTOM */}

                    <input
                      type="number"
                      placeholder="Enter custom donation amount"
                      className="custom-amount-input"
                      value={customAmounts[req._id] || ""}
                      onChange={(e) =>
                        setCustomAmounts((prev) => ({
                          ...prev,
                          [req._id]: e.target.value,
                        }))
                      }
                    />

                    {/* BUTTON */}

                    <button
                      className="contact-btn"
                      disabled={pending <= 0 || loadingId === req._id}
                      onClick={() => handleDonate(req)}
                    >
                      {pending <= 0
                        ? "Goal Achieved"
                        : loadingId === req._id
                          ? "Processing..."
                          : "Donate Now"}
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <p
              style={{
                textAlign: "center",
                color: "#6b7280",
              }}
            >
              No active campaigns available
            </p>
          )}
        </div>

        {/* GENERAL DONATION */}

        <div className="general-donation-wrapper" ref={donationSectionRef}>
          {/* LEFT */}

          <div className="general-donation-card">
            <span className="general-badge">Support Our Mission</span>

            <h2>
              No One Becomes Poor
              <span> By Giving</span>
            </h2>

            <p>
              Your contribution helps us provide food, healthcare, education,
              blood donation, and emergency relief.
            </p>

            {/* SERVICES */}

            <div className="service-tags">
              {donationServices.map((service) => (
                <button
                  key={service}
                  className={
                    selectedService === service ? "active-service" : ""
                  }
                  onClick={() => setSelectedService(service)}
                >
                  {service}
                </button>
              ))}
            </div>

            {/* AMOUNTS */}

            <div className="general-amount-options">
              {generalAmounts.map((amount) => (
                <button
                  key={amount}
                  className={
                    generalAmount === amount && !customGeneralAmount
                      ? "active-general-amount"
                      : ""
                  }
                  onClick={() => {
                    setGeneralAmount(amount);

                    setCustomGeneralAmount("");
                  }}
                >
                  ₹{amount}
                </button>
              ))}
            </div>

            {/* CUSTOM */}

            <input
              type="number"
              placeholder="Enter donation amount"
              className="general-custom-input"
              value={customGeneralAmount}
              onChange={(e) => setCustomGeneralAmount(e.target.value)}
            />

            {/* DONATE */}

            <button
              className="general-donate-btn"
              onClick={handleGeneralDonation}
              disabled={generalLoading}
            >
              {generalLoading
                ? "Processing..."
                : `Donate ₹${customGeneralAmount || generalAmount} Now`}
            </button>
          </div>

          {/* RIGHT */}

          <div className="general-donation-right">
            {/* BANK */}

            <div className="bank-details-card">
              <h3>Bank Details</h3>

              <p>
                <strong>NGO Name : </strong>
                Sarv Sahayata Sangathan
              </p>

              <p>
                <strong>Bank : </strong>
                STATE BANK OF INDIA
              </p>

              <p>
                <strong>Account No : </strong>
                42276919629
              </p>

              <p>
                <strong>IFSC : </strong>
                SBIN0005397
              </p>

              <p>
                <strong>Branch : </strong>
                SBIN0005397
              </p>

              <p>
                <strong>UPI : </strong>
                422769196@sbi
              </p>
              <p>
                <strong>Payment Method : ( PhonePe , Paytm , Google pay)  </strong>
                <strong>Phone Number : : </strong>
                9317803125
              </p>
            </div>

            {/* QR */}

            <div className="qr-card">
              <h3>Scan & Donate</h3>

              <img
                src="/assets/QR.jpeg"
                alt="QR"
              />

              <p>Scan using any UPI app</p>
            </div>
          </div>
        </div>

        {/* =========================================
    NGO SERVICES & MISSION SECTION
========================================= */}

        <div className="mission-section">
          {/* LEFT IMAGE */}

          <div className="mission-image-side">
            <div className="mission-image-wrapper">
              <img src="/assets/bloodlogo.png" alt="NGO Services" />

              <div className="floating-service-card">
                <FaHandsHelping />

                <span>Helping Thousands Of Lives</span>
              </div>
            </div>
          </div>

          {/* RIGHT CONTENT */}

          <div className="mission-content-side">
            <span className="mission-badge">Humanity • Support • Hope</span>

            <h2>
              Together We Can
              <span> Transform Lives</span>
            </h2>

            <div className="mission-line"></div>

            <p>
              Your donations help us provide food distribution, medical support,
              education assistance, blood donation campaigns, emergency relief,
              and child welfare services. Every contribution creates hope for
              someone in need.
            </p>

            {/* SERVICES */}

            <div className="mission-services-grid">
              <div className="mission-service-item">
                <FaHandHoldingHeart />

                <span>Food Distribution</span>
              </div>

              <div className="mission-service-item">
                <FaHeart />

                <span>Medical Support</span>
              </div>

              <div className="mission-service-item">
                <FaUserGraduate />

                <span>Education Support</span>
              </div>

              <div className="mission-service-item">
                <FaTint />

                <span>Blood Donation</span>
              </div>
            </div>

            {/* VISION + MISSION */}

            <div className="vision-mission-grid">
              <div className="vision-box">
                <h3>Our Vision</h3>

                <p>
                  To build a compassionate society where every person receives
                  support, dignity, and hope.
                </p>
              </div>

              <div className="vision-box">
                <h3>Our Mission</h3>

                <p>
                  Delivering healthcare, education, food, emergency aid, and
                  humanity to those in need.
                </p>
              </div>
            </div>

            {/* DONATE BUTTON */}

            <button
              className="general-donate-btn"
              onClick={() => {
                donationSectionRef.current?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              }}
            >
              Donate Now
              <FaArrowRight />
            </button>
          </div>
        </div>

        {/* =========================================
    WHERE YOUR DONATION GOES
========================================= */}

        <div className="impact-section">
          <div className="impact-heading">
            <span className="impact-badge">
              Your Contribution Creates Real Impact
            </span>

            <h2>
              Where Your
              <span> Donation Goes</span>
            </h2>

            <p>
              Every donation helps us provide food, medical care, education,
              blood support, emergency relief, and hope to people who truly need
              it.
            </p>
          </div>

          <div className="impact-grid">
            {/* FOOD */}

            <div className="impact-card">
              <div className="impact-icon">
                <FaHandHoldingHeart />
              </div>

              <h3>Food Distribution</h3>

              <p>
                Nutritious meals are provided to hungry families and children.
              </p>
            </div>

            {/* MEDICAL */}

            <div className="impact-card">
              <div className="impact-icon">
                <FaHeartbeat />
              </div>

              <h3>Medical Support</h3>

              <p>
                Donations help patients receive medicines, tests, and emergency
                treatment.
              </p>
            </div>

            {/* EDUCATION */}

            <div className="impact-card">
              <div className="impact-icon">
                <FaBookOpen />
              </div>

              <h3>Education Support</h3>

              <p>
                Helping underprivileged children with books, school kits, and
                learning resources.
              </p>
            </div>

            {/* BLOOD */}

            <div className="impact-card">
              <div className="impact-icon">
                <FaTint />
              </div>

              <h3>Blood Donation</h3>

              <p>
                Supporting emergency blood requirements and donor campaigns.
              </p>
            </div>

            {/* EMERGENCY */}

            <div className="impact-card">
              <div className="impact-icon">
                <FaAmbulance />
              </div>

              <h3>Emergency Relief</h3>

              <p>
                Providing urgent help during accidents, disasters, and critical
                situations.
              </p>
            </div>

            {/* CHILD CARE */}

            <div className="impact-card">
              <div className="impact-icon">
                <FaChild />
              </div>

              <h3>Child Welfare</h3>

              <p>
                Supporting children with care, nutrition, safety, and better
                opportunities.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Foot />
    </>
  );
}

export default TabsView;
